import equipmentAtom from '@/pages/Equipment/atoms/equipment.atom'
import { useRecoilValue } from 'recoil'
import css from './assignedEquipmentBlock.module.css'
import EmptyPlaceholder from '@/shared/Common/EmptyPlaceholder'
import FavouriteEquipmentLinkItem from '@/pages/Main/Widgets/FavoriteEquipmentWidget/components/FavouriteEquipmentLinkItem'
import { IUser } from '@/pages/Users/users.types'
import { useNavigate } from 'react-router-dom'
import urls from '@/navigation/urls'
import { useMemo } from 'react'
import SkeletonFavouriteEquipmentLinkList from '@/pages/Main/Widgets/FavoriteEquipmentWidget/components/SkeletonFavouriteEquipmentLinkItem'
import commonCss from '../../employePageContentBlock.module.css'
import cn from '@/utils/cn'

interface IProps {
  user: IUser
  loading: boolean
}

const AssignedEquipmentBlock = (props: IProps) => {
  const equipment = useRecoilValue(equipmentAtom).items
  const navigate = useNavigate()

  const filteredEquipment = useMemo(() => {
    if (!props.user || !equipment.length) return []
    return equipment.filter((e) => e.responsibleUsers.some((u) => u.user.id === props.user.id))
  }, [equipment, props.user])

  const renderFavouriteEquipmentList = () => {
    if (props.loading) return <SkeletonFavouriteEquipmentLinkList />

    if (!filteredEquipment.length) {
      return (
        <div className="flex-lines center height100">
          <EmptyPlaceholder inscription="Список закрепленных лифтов пуст" />
        </div>
      )
    }

    return filteredEquipment.map((equipment) => (
      <FavouriteEquipmentLinkItem
        key={equipment.id}
        equipment={equipment}
        onClick={() => navigate(urls.liftScreen(equipment.id))}
      />
    ))
  }

  return (
    <div className={cn(css.wrapper, commonCss.commonBlockSizesWrapper)}>
      <h2 style={{ padding: '6px 8px' }} className="text-heading-4">
        Закрепленные лифты
      </h2>
      <div className={css.listWrapper}>{renderFavouriteEquipmentList()}</div>
    </div>
  )
}

export default AssignedEquipmentBlock
